import { useContext } from 'react';
import Button from '../../ui/Button';
import Heading from '../../ui/Heading';
import ExploreImpactOrganizations from './ExploreImpactOrganizations';
import MyOrganizations from './MyOrganizations';
import { AuthContext } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Notifications from './Notifications';
import MyApplications from './MyApplictions';
import GreenpillBanner from './GreenpillBanner';
import ButtonNew from '../../ui/ButtonNew';

function InfoForUser() {
    const navigate = useNavigate();
    return (
        <div>
            {/* <GreenpillBanner /> */}
            <MyOrganizations />

            <ButtonNew
                className={'mt-3 mb-6'}
                variant="blue"
                size="md"
                fullWidth={true}
                onClick={() => navigate('/createorganization')}
            >
                + Create a new organization
            </ButtonNew>
            <MyApplications />
        </div>
    );
}

export default InfoForUser;
